import React, { useEffect } from "react";
import { nWithCommas } from "../utils";
import { ReactComponent as IconRetiroPendiente } from "../assets/icons/icon_retiro_pendiente.svg";
import { ReactComponent as IconRetiroAplicado } from "../assets/icons/icon_retiro_aplicado.svg";
import { ReactComponent as IconRetiroCancelado } from "../assets/icons/icon_retiro_cancelado.svg";

function ModalEstatusRetiro({ isOpen, onClose, retiro, index, clabe, tipoRetiroTexto }) {
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && isOpen) {
                onClose();
            }
        };
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            window.addEventListener('keydown', handleKeyDown);
        }
        return () => {
            document.body.style.overflow = '';
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, onClose]);

    if (!isOpen || !retiro) return null;

    const statusRaw = retiro.Estatus || '';
    const sUpper = statusRaw.toUpperCase();

    let config = {
        badgeText: statusRaw ? statusRaw.charAt(0).toUpperCase() + statusRaw.slice(1).toLowerCase() : 'Pendiente',
        badgeBg: '#F9B400',
        borderColor: '#F9B400',
        headline: '¡Tu retiro se está procesando!',
        IconComponent: IconRetiroPendiente
    };

    if (sUpper === 'AUTORIZADO' || sUpper === 'APLICADO') {
        config = {
            badgeText: sUpper === 'APLICADO' ? 'Aplicado' : 'Autorizado',
            badgeBg: '#7CC677',
            borderColor: '#7CC677',
            headline: '¡Tu retiro fue autorizado!',
            IconComponent: IconRetiroAplicado
        };
    } else if (sUpper.includes('CANCELADO') || sUpper.includes('RECHAZADO')) {
        config = {
            badgeText: sUpper.includes('RECHAZADO') ? 'Rechazado' : 'Cancelado',
            badgeBg: '#FF6363',
            borderColor: '#FF6363',
            headline: '¡Retiro cancelado!',
            IconComponent: IconRetiroCancelado
        };
    } else {
        // Pendiente / Por autorizar / Proceso / Recibido
        const badgeLabel = sUpper.includes('POR AUTORIZAR') ? 'Por autorizar' : 'Pendiente';
        config = {
            badgeText: badgeLabel,
            badgeBg: '#F9B400',
            borderColor: '#F9B400',
            headline: '¡Tu retiro se está procesando!',
            IconComponent: IconRetiroPendiente
        };
    }

    const { badgeText, badgeBg, borderColor, headline, IconComponent } = config;

    // Formatear Fecha: YYYYMMDD -> DD/MM/YY
    const formatFecha = (raw) => {
        if (!raw) return '-';
        const str = String(raw).trim();
        if (str.length === 8 && /^\d{8}$/.test(str)) {
            return `${str.substring(6, 8)}/${str.substring(4, 6)}/${str.substring(2, 4)}`;
        }
        if (str.includes('-')) {
            const parts = str.split('T')[0].split('-');
            if (parts.length === 3) {
                const y = parts[0].slice(-2);
                const m = parts[1];
                const d = parts[2];
                return `${d}/${m}/${y}`;
            }
        }
        return str;
    };

    // Monto
    const rawMonto = retiro.Monto;
    const numMonto = typeof rawMonto === 'string' ? parseFloat(rawMonto.replace(/,/g, '')) : (rawMonto || 0);
    const montoFormatted = !isNaN(numMonto) ? `$ ${nWithCommas(Math.abs(numMonto).toFixed(2))}` : '-';

    // Cuenta CLABE (mostrar solo si existe y no es 'Sin cuenta registrada' ni placeholder)
    const clabeVal = retiro.Clabe || (clabe !== 'Cuenta de Depósito' ? clabe : '') || '';
    const hasClabe = Boolean(
        clabeVal && 
        clabeVal !== 'Sin cuenta registrada' && 
        clabeVal !== 'Cuenta de Depósito' && 
        clabeVal.trim() !== ''
    );

    // Título superior: 'Retiro X'
    const tituloRetiro = retiro.NumeroRetiro || (retiro.IdRetiro ? `Retiro ${retiro.IdRetiro}` : (retiro.Folio ? `Retiro ${retiro.Folio}` : (index !== undefined && index !== null ? `Retiro ${index}` : 'Retiro')));

    return (
        <div 
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                zIndex: 1050,
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'stretch',
                animation: 'modalBackdropFadeIn 0.2s ease-in-out'
            }}
            onClick={onClose}
        >
            <style>{`
                @keyframes modalDrawerSlideIn {
                    from { transform: translateX(100%); }
                    to { transform: translateX(0); }
                }
                @keyframes modalBackdropFadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
            `}</style>
            <div 
                style={{
                    width: '100%',
                    maxWidth: '420px',
                    height: '100%',
                    backgroundColor: '#ffffff',
                    boxShadow: '-4px 0 24px rgba(0, 0, 0, 0.15)',
                    display: 'flex',
                    flexDirection: 'column',
                    overflowY: 'auto',
                    animation: 'modalDrawerSlideIn 0.25s ease-out'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header del Modal */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '18px 24px',
                    borderBottom: '1px solid #f1f5f9'
                }}>
                    <h5 className="txtBold" style={{ margin: 0, color: '#202A52', fontSize: '18px', fontWeight: 700 }}>
                        {tituloRetiro}
                    </h5>
                    <button 
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#202A52',
                            padding: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '4px'
                        }}
                        title="Cerrar"
                    >
                        <i className="material-icons" style={{ fontSize: '22px', color: '#202A52' }}>close</i>
                    </button>
                </div>

                {/* Contenido del Modal */}
                <div style={{ padding: '24px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                    {/* Card Principal con borde dinámico */}
                    <div style={{
                        border: `1.5px solid ${borderColor}`,
                        borderRadius: '12px',
                        padding: '24px 20px',
                        backgroundColor: '#ffffff'
                    }}>
                        {/* Badge de Estatus */}
                        <div style={{
                            backgroundColor: badgeBg,
                            color: '#ffffff',
                            padding: '4px 14px',
                            borderRadius: '16px',
                            display: 'inline-block',
                            fontSize: '13px',
                            fontWeight: 700,
                            lineHeight: '1.4'
                        }}>
                            {badgeText}
                        </div>

                        {/* Icono central */}
                        <div style={{ display: 'flex', justifyContent: 'center', margin: '1.5rem 0 1rem 0' }}>
                            <IconComponent style={{ width: '84px', height: '84px' }} />
                        </div>

                        {/* Titular */}
                        <h4 className="txtBold" style={{
                            fontSize: '22px',
                            fontWeight: 700,
                            color: '#202A52',
                            textAlign: 'center',
                            margin: '0 0 2rem 0'
                        }}>
                            {headline}
                        </h4>

                        {/* Filas de Información */}
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {/* Fecha de solicitud */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '12px 0',
                                borderBottom: '1px solid #f1f5f9'
                            }}>
                                <span style={{ color: '#94a3b8', fontSize: '14px' }}>Fecha de solicitud:</span>
                                <span style={{ color: '#475569', fontSize: '14px', fontWeight: 500 }}>
                                    {formatFecha(retiro.FechaSolicitud || retiro.Fecha)}
                                </span>
                            </div>

                            {/* Tipo de retiro */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '12px 0',
                                borderBottom: '1px solid #f1f5f9'
                            }}>
                                <span style={{ color: '#94a3b8', fontSize: '14px' }}>Tipo de retiro:</span>
                                <span style={{ color: '#475569', fontSize: '14px', fontWeight: 500 }}>
                                    {tipoRetiroTexto || retiro.TipoRetiro || retiro.Descripcion || '-'}
                                </span>
                            </div>

                            {/* Importe de retiro */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '12px 0',
                                borderBottom: hasClabe ? '1px solid #f1f5f9' : 'none'
                            }}>
                                <span style={{ color: '#94a3b8', fontSize: '14px' }}>Importe de retiro:</span>
                                <span style={{ color: '#475569', fontSize: '14px', fontWeight: 500 }}>
                                    {montoFormatted}
                                </span>
                            </div>

                            {/* Cuenta CLABE (Condicional) */}
                            {hasClabe && (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '12px 0'
                                }}>
                                    <span style={{ color: '#94a3b8', fontSize: '14px' }}>Cuenta CLABE:</span>
                                    <span style={{ color: '#475569', fontSize: '14px', fontWeight: 500 }}>
                                        {clabeVal}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Tarjeta Informativa "¿No reconoces está operación?" */}
                    <div style={{
                        backgroundColor: '#eef9fa',
                        border: '1px solid #d8f1f5',
                        borderRadius: '10px',
                        padding: '14px 16px',
                        marginTop: '1.5rem',
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '12px'
                    }}>
                        <i className="material-icons" style={{ color: '#00b4d8', fontSize: '24px', marginTop: '1px', flexShrink: 0 }}>
                            info_outline
                        </i>
                        <div style={{ fontSize: '12px', color: '#475569', lineHeight: '1.4' }}>
                            <div style={{ fontWeight: 700, color: '#334155', marginBottom: '3px' }}>
                                ¿No reconoces está operación?
                            </div>
                            <div>
                                Contáctanos en{' '}
                                <a 
                                    href="mailto:solucionesempleados@valmex.mx" 
                                    style={{ color: '#0097a7', textDecoration: 'none', fontWeight: 600 }}
                                >
                                    solucionesempleados@valmex.mx
                                </a>
                            </div>
                            <div>
                                o al{' '}
                                <a 
                                    href="tel:8000082563" 
                                    style={{ color: '#0097a7', textDecoration: 'none', fontWeight: 600 }}
                                >
                                    800 0082 563
                                </a>{' '}
                                para recibir asistencia.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalEstatusRetiro;
